import { Modal } from '@/components/common/AppModal';
import { Alert, Button, ListGroup } from 'react-bootstrap';
import SubtleBadge from '@/components/common/SubtleBadge';
import type { RecentIndexUrl } from '../api/types';
import { IndexerIcon } from './IndexerIcon';
import { decodeUrlForDisplay, formatFaNumber, formatTime } from '../lib/utils';

function RecentUrlRow({ item }: { item: RecentIndexUrl }) {
  return (
    <ListGroup.Item className="bg-transparent py-2 px-3">
      <div
        className="mono text-break fs--1 text-primary lh-sm"
        dir="ltr"
        title={item.url}
      >
        {decodeUrlForDisplay(item.url)}
      </div>
      <div className="d-flex flex-wrap align-items-center gap-2 mt-2">
        <SubtleBadge
          bg={item.success ? 'success' : 'danger'}
          pill
          className="fs--2"
        >
          {item.success ? 'موفق' : 'ناموفق'}
        </SubtleBadge>
        <span className="text-secondary fs--2 d-inline-flex align-items-center gap-1">
          <IndexerIcon name="clock-history" />
          آخرین درخواست: {formatTime(item.lastRequestedAt)}
        </span>
      </div>
    </ListGroup.Item>
  );
}

export function RecentIndexWarningModal({
  show,
  windowHours,
  urls,
  onRemove,
  onContinue,
  onClose,
}: {
  show: boolean;
  windowHours: number;
  urls: RecentIndexUrl[];
  onRemove: () => void;
  onContinue: () => void;
  onClose: () => void;
}) {
  return (
    <Modal show={show} onHide={onClose} centered scrollable>
      <Modal.Header closeButton className="bg-body-tertiary border-bottom py-2">
        <Modal.Title as="div" className="fs--1 fw-semibold mb-0 lh-sm">
          درخواست تکراری در {windowHours} ساعت گذشته
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-3">
        <Alert variant="warning" className="mb-0 py-2 fs--1">
          این آدرس‌ها در {windowHours} ساعت گذشته برای گوگل ارسال شده‌اند.
          درخواست دوباره بودجه Indexing API را کم می‌کند و گوگل معمولاً اثر
          اضافه‌ای برای اعلان تکراری نمی‌گذارد.
        </Alert>

        <div className="d-flex flex-column flex-sm-row gap-2 my-3">
          <div className="flex-fill border rounded-3 px-3 py-2 bg-body-tertiary">
            <div className="fw-semibold fs--1 mb-1">حذف شود</div>
            <p className="text-secondary fs--2 mb-0">
              آدرس‌های تکراری از لیست ارسال برداشته می‌شوند.
            </p>
          </div>
          <div className="flex-fill border rounded-3 px-3 py-2 bg-body-tertiary">
            <div className="fw-semibold fs--1 mb-1">ادامه بده</div>
            <p className="text-secondary fs--2 mb-0">
              همان آدرس‌ها دوباره برای گوگل ارسال می‌شوند.
            </p>
          </div>
        </div>

        <div className="d-flex align-items-center justify-content-between mb-2">
          <span className="text-secondary fs--1">
            {formatFaNumber(urls.length)} آدرس تکراری
          </span>
        </div>

        <ListGroup
          variant="flush"
          className="border rounded-3 overflow-auto bg-body"
          style={{ maxHeight: 'min(16rem, 40vh)' }}
        >
          {urls.map((item) => (
            <RecentUrlRow key={item.url} item={item} />
          ))}
        </ListGroup>
      </Modal.Body>
      <Modal.Footer className="bg-body-tertiary border-top py-2">
        <Button size="sm" variant="outline-secondary" onClick={onRemove}>
          حذف شود
        </Button>
        <Button size="sm" variant="primary" onClick={onContinue}>
          ادامه بده
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
